import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createPartyDocument = async (details) => {
    // get the reference to the Firestore document
    const batch = db.batch();
    const uniqueId = uuidv4();
    const docRef = db.collection('Party').doc();

    //create user object
    details.uniqueId = uniqueId;
    details.PartyPostedDateTime = new Date();

    // write to Cloud Firestore
    const collectionRef = await db.collection('Party').doc();
    batch.set(collectionRef, details);
    batch.commit().then(() => {
        return true;
    }).catch((error)=> {
        return false
    });
}

export const getPartyDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Party').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id, id: doc.id}));
}

export const getClientDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Party').where("userId","==", userId).where("PartyType","==", 'Client').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id, id: doc.id}));
}

export const getVendorDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Party').where("userId","==", userId).where("PartyType","==", 'Vendor').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id, id: doc.id}));
}

export const getPartyDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Party').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getPartyDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let product = null;
    let retailer = null;
    const productSnapshot = await db.collection('Party').where("uniqueId", "==", uniqueId).get()
    productSnapshot.docs.map(doc => {
        product = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("uid", "==", product.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        product: product,
        retailer: retailer
    }
}

export const getAllPartyDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Party').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updatePartyDocument = async (product) => {
    const docRef = db.doc(`/Party/${product._id}`);
    return docRef.update(product);
}